import React from 'react';
import { useTranslation } from 'react-i18next';

// assets
import captureVideo from 'onboarding/assets/onboarding-capture.mp4';

// styles
import * as Buttons from 'theme/components/Buttons.style';
import * as Styled from 'onboarding/styles/SlideCapture.style';

interface SlideCaptureProps {
  onContinue: () => void;
}

function SlideCapture({ onContinue }: SlideCaptureProps): JSX.Element {
  const { t } = useTranslation('pageOnboarding');

  return (
    <Styled.Slide>
      <Styled.VideoSection>
        <Styled.Video
          src={captureVideo}
          autoPlay
          loop
          muted
          playsInline
          aria-hidden="true"
        />
      </Styled.VideoSection>

      <Styled.BottomSection>
        <Styled.TextSection>
          <Styled.Header>
            {t('SlideCapture.headerLine1')}
            <br />
            {t('SlideCapture.headerLine2')}
          </Styled.Header>
          <Styled.Description>
            {t('SlideCapture.description')}
          </Styled.Description>
        </Styled.TextSection>

        <Buttons.Primary onClick={onContinue} stretch>
          {t('Buttons.continue')}
        </Buttons.Primary>
      </Styled.BottomSection>
    </Styled.Slide>
  );
}

export default SlideCapture;
